<template>
  <div id="doctors" class="doctors">
    <Doctor :doctor="doctor" :type="1" :id="doctorId"></Doctor>

    <div class="con border2">
      <h2>执业医院</h2>
      <p>{{ doctor.hospital }}</p>
    </div>

    <div class="con">
      <h2>专业领域</h2>
      <p>{{ doctor.good_at }}</p>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import Doctor from '../components/Doctor';

  export default {
    name: 'doctor',
    data() {
      return {
        msg: '医生详情',
        doctorId: null
      };
    },
    components: {Doctor},
    computed: {
      ...mapState([
        'doctor'
      ])
    },
    beforeCreate() {
      // 更新顶部状态
      this.$store.dispatch('updateNav', {
        title: '医生详情',
        type: 'center'
      });
    },
    mounted() {},
    created() {
      // 发埋点
      if (window.Tracking && typeof window.Tracking.initTrackUrl === 'function') {
        window.Tracking.initTrackUrl(2, 'djk_kwys_ym_ysxq', '');
      }

      this.doctorId = this.$route.params.doctorId;

      // 如果医生信息不存在，请求接口
      if (!this.doctor.name) {
        // 获取医生详情
        this.$store.dispatch('getDoctorDetail', {
          doctorid: this.$route.params.id
        });
      }
    },
    methods: {}
  };
</script>

<style  lang="less" src="./../assets/doctors.less"></style>



// WEBPACK FOOTER //
// Doctors.vue?239e237a